import { ReactNode, useRef, useState } from "react";
import PageIcon from "./Icons/PageIcon";
import EditIcon from "./Icons/EditIcon";
import LightGearIcon from "./Icons/LightGearIcon";
import React from "react";
import HoverToolTip from "./HoverToolTip";
import WebDesigner from "./WebDesigner";



enum TabType{
    Settings = 0,
    Pages = 1,
    Design = 2,
    Blog = 3,

}




export default function LeftPanel({settings,pages,design,initialState= 0,onChange,businessName,designer,blog}:{settings:ReactNode,pages:ReactNode,design:ReactNode,blog?:ReactNode,initialState:number,onChange:Function|undefined,businessName?:string,designer:WebDesigner}){

    const [selectedTab, setSelectedTab] = useState(initialState);

    const updateSelected = (newTab:TabType)=>{


        const change = ()=>{
        onChange&&onChange(newTab);
        setSelectedTab(newTab);
        if(designer.onDeselectMenu){
            designer.onDeselectMenu();
        }

        }
        if(designer.panelMenuLocked && newTab != TabType.Settings){
            designer.promptForPanelExit(change);
        }
        else
        change();
    }

    if(designer){
        designer.openSettingsMenu = ()=>{
            setSelectedTab(TabType.Settings);
        }
    }

    // const { IsPurchasedDomain } = store.getState().Business;
    return (
        <>
   
        <TabRow  selectedTab={selectedTab} updateSelected={updateSelected}/>

        <div id="settings-content"  style={(selectedTab==TabType.Settings)?{}:{display:"none"}}>
            {/* <ConnectDomainClickAd  DomainNotPurcheshed={IsPurchasedDomain === false && designer.state.panelMenuState !== PannelMenuType.Domains} designer={designer}/> */}
            {settings}
        </div>
   
        { selectedTab==TabType.Pages&&
        <div id="page-content relative">
            {pages}
        </div>
        }
        { selectedTab==TabType.Design&&
        <div id="design-content">
            {design}
        </div>
        }
        </>
    )

}
// const WithTooldtip = (props: any) => (
//     <OverlayTrigger
//       trigger={["hover","focus"]}
//       overlay={<Tooltip id={props.id}>{props.title}</Tooltip>}
//     >
//       {props.children}
//     </OverlayTrigger>

//   );
function TabRow({selectedTab,updateSelected}:{selectedTab:TabType,updateSelected:(tabType:TabType)=>void}){
    return (
        <div className="panel-tabs">
                     
              
               
            <TabButton selected={selectedTab} tabType={TabType.Settings} label={<LightGearIcon/>}  updateSelected = {updateSelected} >
                <HoverToolTip text="Settings" forceAbove={true}/>
            </TabButton>
            <TabButton selected={selectedTab } tabType={TabType.Pages} label={<PageIcon/>}  updateSelected = {updateSelected}>
            <HoverToolTip text="Pages" forceAbove={true}/>
                </TabButton>
            <TabButton selected={selectedTab} tabType={TabType.Design} label={<EditIcon/>}  updateSelected = {updateSelected}>
                <HoverToolTip text="Components" forceAbove={true}/>
            </TabButton>
        </div>
    )
}
declare global {
    interface Window { ClicktoSettingDomains: any; }
}

function TabButton({selected,tabType,label,updateSelected,children}:{selected:TabType,tabType:TabType,children?:any,label:ReactNode,updateSelected:(tabType:TabType)=>void}){
    const ButtonRef =  useRef<HTMLButtonElement>(null);
    if (tabType === TabType.Settings) {
        window.ClicktoSettingDomains = ()=> {
            if (ButtonRef.current) {
                ButtonRef.current.click();
                setTimeout(() => {
                    (window as any).ClicktoDomains();
                }, 100);

            }
        }
    }
    const isSelected = selected == tabType;
    return (
        <button ref={ButtonRef} className={`tab-button invisible-button ${isSelected?"selected":""}`} onClick={()=>updateSelected(tabType)}>
            {label}
            {children}
        </button>
    )
}

// function BlogIcon(){
//     return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" height="1em"><path d="M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144L0 368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144l-16 0 0 96 16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48l0-224z"/></svg>

// }